export default (theme) => ({
    root: {
        backgroundColor: theme.colors.primary.white,
        borderRadius: 12,
        color: theme.colors.actionMajor[500],
        cursor: 'pointer',
        display: 'flex',
        width: 24,
        height: 24,
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: theme.colors.actionMajor[500],
            color: theme.colors.primary.white,
        },
    },
    menuContent: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 248,
    },
    menuItem: {
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
        gap: 8,
        padding: '8px 12px',
        transition: 'background-color 0.2s ease',
        '&:hover': {
            backgroundColor: theme.colors.actionMinor[50],
        },
    },
    open: {
        backgroundColor: theme.colors.actionMajor[500],
        color: theme.colors.primary.white,
        transform: 'rotate(-90deg)',
    },
    popover: {
        '& .hoi-poi-popover-inner': {
            padding: 12,
        },
    },
});
